module.exports = __webpack_public_path__ + "img/ioswhite.cf6cc91b.png";